import { getDateRangeISOString } from 'hybridspace-common/lib/utils/getDateRangeISOString';
import { createObservableOperation } from 'owa-observable-operation';

import fetchCalendarView from './fetchCalendarView';

import type { DateRange } from 'owa-datetime-utils';
import type { CalendarEvent } from 'owa-graph-schema';

const dest = createObservableOperation(
    'PLACES_LOAD_CALENDAR_VIEW',
    (
        dateRange: DateRange,
        origin: any,
        maxResults?: number,
        filterAllDayEvents?: boolean
    ): {
        dateRange: DateRange;
        origin: any;
        maxResults: number | undefined;
        filterAllDayEvents: boolean | undefined;
    } => ({
        dateRange,
        origin,
        maxResults,
        filterAllDayEvents,
    }),
    ({ dateRange }) => getDateRangeISOString(dateRange),
    ({ dateRange, maxResults, filterAllDayEvents }) =>
        fetchCalendarView(dateRange.start, dateRange.end, origin, maxResults, filterAllDayEvents)
);
const loadCalendarViewSucceeded: (
    actionMessage: {
        dateRange: DateRange;
        origin: any;
        maxResults: number | undefined;
        filterAllDayEvents: boolean | undefined;
    } & {
        result: CalendarEvent[];
    }
) => {
    dateRange: DateRange;
    origin: any;
    maxResults: number | undefined;
    filterAllDayEvents: boolean | undefined;
} & {
    result: CalendarEvent[];
} = dest.onSucceeded;
const loadCalendarView: (
    dateRange: DateRange,
    origin: any,
    maxResults?: number,
    filterAllDayEvents?: boolean
) => {
    dateRange: DateRange;
    origin: any;
    maxResults: number | undefined;
    filterAllDayEvents: boolean | undefined;
} = dest.start;

export { loadCalendarViewSucceeded, loadCalendarView };
